import { useContext } from "react";
import { SessionMetadataContext } from "contexts/SessionMetadata/context";
import { metadataDisplayValue } from "lib/metadata-qr";

export function SessionDetailsSummary() {
  const { fields, values, edit } = useContext(SessionMetadataContext);
  if (!fields.length) return null;
  return (
    <section
      className="mb-6 flex items-start gap-3 rounded-xl bg-f4f7ff px-4 py-3"
      aria-label="Session details"
    >
      <dl className="min-w-0 flex-1 space-y-3">
        {fields.map((field) => (
          <div key={field.id} className="text-sm">
            <dt className="text-858494">{field.title}</dt>
            <dd className="break-words font-medium">
              {metadataDisplayValue(field, values[field.id]) || "Not set"}
            </dd>
          </div>
        ))}
      </dl>
      <button
        type="button"
        aria-label="Edit session details"
        className="shrink-0 text-3461fd text-sm py-2"
        onClick={edit}
      >
        Edit
      </button>
    </section>
  );
}
